export default __webpack_public_path__ + "static/media/job_referral.8b5217f7.webp";